import React from 'react'
import Box from '@material-ui/core/Box'
import clsx from 'clsx'
import { makeStyles } from '@material-ui/core/styles'
import {
  BACK_BUTTON_SLOT_WIDTH,
  pageHeaderGridColumns,
  pageHeaderHorizontalPadding,
  pageHeaderLabelColumn,
} from './page-header-layout'

export const PageHeaderTabsContext = React.createContext(false)

export { pageHeaderHorizontalPadding }

const useStyles = makeStyles(theme => ({
  tabsSection: {
    width: '100%',
  },
  tabsDivider: {
    width: '100%',
    borderBottom: `1px solid ${theme.palette.divider}`,
  },
  tabsRow: ({ hasCrumbs, includeHorizontalPadding }) => ({
    display: 'grid',
    gridTemplateColumns: pageHeaderGridColumns(hasCrumbs),
    alignItems: 'stretch',
    ...(includeHorizontalPadding ? pageHeaderHorizontalPadding(theme) : {}),
  }),
  backButtonSlot: {
    width: BACK_BUTTON_SLOT_WIDTH,
    flexShrink: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  backButtonPlaceholder: {
    width: 35,
    height: 35,
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2),
    flexShrink: 0,
  },
  tabsContent: ({ hasCrumbs, useStudentTitleOffset }) => ({
    minWidth: 0,
    ...pageHeaderLabelColumn(theme, hasCrumbs),
    ...(useStudentTitleOffset
      ? {
        [theme.breakpoints.up('sm')]: {
          paddingLeft: theme.spacing(3),
        },
      }
      : {}),
  }),
}))

export default function PageHeaderTabsSection({
  children,
  reserveBackButtonColumn = false,
  backButtonContainerClassName,
  titleContainerClassName,
  hasCrumbs = false,
  useStudentTitleOffset = false,
  includeHorizontalPadding = true,
}) {
  const classes = useStyles({
    hasCrumbs,
    useStudentTitleOffset,
    includeHorizontalPadding,
  })
  const contentClassName = titleContainerClassName || classes.tabsContent

  return (
    <PageHeaderTabsContext.Provider value>
      <Box className={classes.tabsSection}>
        <Box className={classes.tabsRow}>
          {hasCrumbs ? (
            <Box
              className={clsx(
                classes.backButtonSlot,
                backButtonContainerClassName,
              )}
            >
              {reserveBackButtonColumn ? (
                <Box className={classes.backButtonPlaceholder} aria-hidden />
              ) : null}
            </Box>
          ) : null}
          <Box className={contentClassName}>{children}</Box>
        </Box>
        <Box className={classes.tabsDivider} aria-hidden />
      </Box>
    </PageHeaderTabsContext.Provider>
  )
}
